import React, { useState, useEffect} from "react";
import { Typography, TextField, Grid, Dialog, DialogContent, CircularProgress, FormControl, Select, MenuItem, Box } from "@mui/material";
import '../../style/signIn.css';
import '../../style/common.css';
import { useNavigate, useLocation } from "react-router-dom";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import appConfig from "../../config/appConfig";
import * as menuActions from '../../store/actions/breadcrumb';
import '../../style/common.css';
import * as Styled from '../../components/styled-components/Styled-Components';
import RadioButtonGroup from '../../components/RadioButtonGroup';
import BusinessUnitLocationMapping from '../SignIn/BusinessUnitLocationMapping';
import { useForm, Controller } from 'react-hook-form';
import {  createUserWithEmailAndPassword  } from 'firebase/auth';
import * as userActions from '../../store/actions/userManagement';
import { useLogout } from '../../components/Utils';
import {auth} from '../../config/firebase-config'
import { useTranslation } from 'react-i18next';
import languageicon from "../../assets/internet-icon.svg";


const textboxCss = {
    borderRadius: "3px",
    outline: "none",
    '&.MuiFormControl-root': {
        margin: "0"
    },
    '&.MuiTextField-root': {
        backgroundColor: '#fff'
    },
    '& .MuiInputBase-input': {
        backgroundColor: '#fff',
        fontSize: 16,
        fontFamily: appConfig.fontfamily,
        padding: "10px 14px",
        borderRadius: "3px",
        outline: "none",
        height: "35px",
        boxSizing: 'border-box',
        border: `1px solid ${appConfig.colors.secondaryBlue}`,
    },
    '& .MuiOutlinedInput-root': {
        padding: '0',
    }
};

const ErrorStyle = {
    color: "red",
    display: 'flex',
    marginTop: '5px'
  }

const SelfRegistration = ({ openDialog, onClose, setBreadcrumb, createNewUserMgt, createdUserMgtData, getRolesLov, rolesLov, getBUnitLov, bunitFilterCommonList }) => {

const langs = {
    "en": "English",
    "gr": "German",
    "sp_mex": "Spanish (Mexico)",
    "sp_sp": "Spanish (Spain)",
    "sl": "Slovakia",
    "ch": "Chinese",
    "pr": "Portuguese"
};

const { i18n } = useTranslation('common');
const { t } = useTranslation('common');
const [language, setLanguage] = useState("en"); // Default language

const params = useLocation();
const navigate = useNavigate();
const { register, handleSubmit, formState: { errors }, control,setValue } = useForm();
const [roles, setRoles] = useState();
const [filterList, setFilterList] = useState([]);

const [isAdminUser, setIsAdminUser] = useState('No');
const [isadminUserErr, setAdminUserErr] = useState("");
const [isActive, setIsActive] = useState("");
const [selectedItems, setSelectedItems] = useState([]);
const [apiError, setAPIError] = useState("")
const [locationError, setLocationErr] = useState(false);
const [isLoading, setIsLoading] = useState(false);
const [locationsData, setLocationsData] = useState({});
const onLogout = useLogout();
const email = window.sessionStorage.getItem("user_name") || JSON.parse(window.localStorage.getItem('userInfo')).email;
const name = window.sessionStorage.getItem("userFullName") || JSON.parse(window.localStorage.getItem('userInfo')).name;
const nameParts = name?.trim().split(' ');
const first_Name = nameParts[0];
const middle_Name = nameParts.length > 2 ? nameParts.slice(1, -1).join(' ') : '';
const last_Name = nameParts.length === 1 ? '' : nameParts[nameParts.length - 1];


useEffect(() => {
    const storedLanguage = sessionStorage.getItem("language") || "en";
    setLanguage(storedLanguage);
    i18n.changeLanguage(storedLanguage);
  }, [i18n]);

useEffect(()=>{
    if(bunitFilterCommonList && bunitFilterCommonList?.length !== 0){
      const dataArr = bunitFilterCommonList?.data || []
      let locationData = {
      }
      dataArr?.forEach(input => {
          locationData[input.businessUnitName] = input.businessLocation ? input.businessLocation : input.businessUnitLocations || []
      });
      setLocationsData(locationData);
    }
    },[bunitFilterCommonList])

useEffect(() => {
    const subMenuData = {
        name: t("User Management"),
        route: "/user-management",
        subRoutes: "create-user",
        subRoutesLabel: t("Create"),
        isSubMenu: true
    }
    getRolesLov()
    setValue('isActive',  "Yes" )
    setValue("firstname", first_Name)
    setValue("middlename", middle_Name)
    setValue("lastname", last_Name)
    setBreadcrumb(subMenuData)
  }, []);

  useEffect(()=>{
    getBUnitLov();
  },[])



  const handleFormSubmit = (data) => {
        if(isAdminUser === 'No' && selectedItems && selectedItems.length === 0){
            setLocationErr(true)
            return
        }
        setLocationErr(false)
    const errorKeys = Object.keys(errors)
    if(errorKeys.length === 0){
        sendFormValues(data);
    }
}
const generatePassword = () => {
    let charset = "";
    let newPassword = "";
    const passwordLength = 12;

    charset += "!@#$%^&*";
    charset += "0123456789";
    charset += "abcdefghijklmnopqrstuvwxyz";
     charset += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

    for (let i = 0; i < passwordLength; i++) {
        newPassword += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return newPassword
};

const sendFormValues = (formData) => {
    let roleObject = [];
    setAPIError("");
    if(formData?.isAdminUser === "Yes"){
        roleObject =  roles?.filter((role)=>role.code === "ADMIN")
    }else {
        roleObject =  roles?.filter((role)=>role.code === "MRUSER")
    }
    setIsLoading(true);
    const data = {
            "email": email,
            "password": generatePassword(),
            "firstName": formData?.firstname,
            "middleName": formData?.middlename,
            "lastName": formData?.lastname,
            "roleId": 202,
            // "roleId": roleObject && roleObject[0] && roleObject[0].id ? roleObject[0].id  : (formData?.isAdminUser === "Yes" ? 201 : 202),
            // "isActive": formData?.isActive === "Yes" ? true : false,
            "isActive": true,
            "locationIdList": selectedItems,
            "lastModifiedBy": "Build Script",
            "langPreference": language,
            "isSelfRegistration": true
          }
          sessionStorage.setItem("language", language)
          createNewUserMgt(data)
}
useEffect(() => {
    if(createdUserMgtData && createdUserMgtData.status === 200) {
        setIsLoading(false);
        onClose();
        window.location.href = '/home'
    }
    else if (createdUserMgtData && createdUserMgtData.status === 403 || createdUserMgtData && createdUserMgtData.status === 500){
        setIsLoading(false);
        setAPIError(createdUserMgtData.message)
    }
    else if (createdUserMgtData && createdUserMgtData.status === 401){
        setIsLoading(false);
        onLogout();
    }
}, [createdUserMgtData]);

useEffect(()=>{
    if(rolesLov && rolesLov.status === 200 ){
        setRoles(rolesLov.data)
    } else if(rolesLov && rolesLov.status === 401){ 
        onLogout();
    }

},[rolesLov])

const addUser = async (data) => {
   try{
    // const userCredential = await createUserWithEmailAndPassword(auth, data.email, data.password);
    // const newData = { ...data, uid: userCredential?.user?.uid };
    const payload = {
        email: data.email,
        uid: null
    }
    createNewUserMgt(payload);
   }catch(e){
    setIsLoading(false);
    if(e.code === "auth/email-already-in-use"){
        setAPIError(t("Email Address already exists"))
    }else{
        setAPIError(t("Something went wrong"))
    }
   }
}
const handleChange = (e) => {
    const newValue = e.target.value;
    i18n.changeLanguage(newValue);
    setLanguage(newValue);
    sessionStorage.setItem("language", newValue); // Save to session storage
  };
  
  return (
    <>
       <Dialog
        open={openDialog}
        className="small-dialog dialog-box"
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
        >
            <DialogContent className="content-dialog" style={{justifyContent: "flex-start"}}>
            <Typography component="h1" variant="h5" className="mb-20 mt-30">
                Self Registration
            </Typography>
            <form onSubmit={handleSubmit(handleFormSubmit)} style={{textAlign: 'left', width: '100%'}}>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item  sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Email Address")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <TextField
                                // {...register('email', { required: true, pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i})}
                                margin="normal"
                                id="email"
                                sx={textboxCss}
                                value={email}
                                disabled
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "email" }}
                            />
                        </div>
                        {errors?.email?.type === "required" && <span style={ErrorStyle}>{t("Please enter email id")}</span>}
                        {errors?.email?.type === "pattern" && (<span style={ErrorStyle}>{t("Please enter valid email id")}</span>)}
                        {apiError && (<span style={ErrorStyle}>{apiError}</span>) }
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6} xl={6} lg={6} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black, textTransform: 'capitalize' }} className='xxs-normal'>{t("First Name")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <TextField
                                {...register('firstname', { required: true, validate: value => value.trim() !== '' || t("Please enter first name"), pattern: /^[A-Za-z0-9'._\-!#^~ ]+$/ })}
                                margin="normal"
                                id="firstname"
                                // disabled={first_Name !== ""} 
                                sx={textboxCss}
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "first name" }}
                            />
                        </div>
                        {(errors?.firstname?.type === "required" || errors?.firstname?.type === "validate") && <span style={ErrorStyle}>{t("Please enter first name")}</span>}
                        {errors?.firstname?.type === "pattern" && (<span style={ErrorStyle}>{t("Special characters not allowed")}</span>)}
                    </Grid>
                    <Grid item md={6} xl={6} lg={6} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black, textTransform: 'capitalize' }} className='xxs-normal'>{t("Middle Initial")}</Typography>
                            <TextField
                                {...register('middlename', { required: false})}
                                margin="normal"
                                id="middlename"
                                // disabled={middle_Name !== ""} 
                                sx={textboxCss}
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "middle name" }}
                            />
                        </div>
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item m sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black, textTransform: 'capitalize' }} className='xxs-normal'>{t("Last Name")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <TextField
                                {...register('lastname', { required: true, validate: value => value.trim() !== '' || t("Please enter last name"), pattern: /^[A-Za-z0-9'._\-!#^~ ]+$/})}
                                margin="normal"
                                id="lastname"
                                sx={textboxCss}
                                // disabled={last_Name !== ""} 
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "last name" }}
                            />
                        </div>
                        {(errors?.lastname?.type === "required" || errors?.lastName?.type === "validate") && <span style={ErrorStyle}>{t("Please enter last name")}</span>}
                        {errors?.lastname?.type === "pattern" && (<span style={ErrorStyle}>{t("Special characters not allowed")}</span>)}
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item m sm={12} xs={12}>
                        <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Language")}</Typography>
                        <div style={{ marginLeft: 'auto', display: 'flex' }} id="languageMenu">
                            <FormControl sx={{ m: 1 }} style={{width: '100%', margin: 0}}>
                            <Select
                                labelId="demo-simple-select-label"
                                id="language-select"
                                style={{border: '1px solid #005974', padding: 0, height: 35, width: '100%'}}
                                label="Language"
                                value={language}
                                onChange={handleChange}
                                renderValue={(value) => (
                                <Box sx={{ display: "flex", gap: 1 }}>
                                    <img src={languageicon} alt="language" />
                                    {langs[value]}
                                </Box>
                                )}
                            >
                                {Object.keys(langs).map((key) => (
                                <MenuItem key={key} value={key}>
                                    <Box sx={{ display: "flex", gap: 1, fontSize: 14 }}>
                                    <img src={languageicon} alt="language" />
                                    {langs[key]}
                                    </Box>
                                </MenuItem>
                                ))}
                            </Select>
                            </FormControl>
                        </div>
                    </Grid>
                </Grid>
                {/* <Grid container spacing={2} className='mb-20'>
                    <Grid item m sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Admin User")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <Controller
                                name="isAdminUser"
                                control={control}
                                rules={{ required: isAdminUser === "No" ? true : false}} // Add the required rule
                                render={({ field }) => (
                                    <>
                                    <RadioButtonGroup
                                        key={field.value}
                                        className={['create-using-account-radio', field.value === "Yes" ? "yes" : "no"].join(' ')}
                                        value={field.value}
                                        labels={['Yes', 'No']}
                                        handleChange={(value) => {setIsAdminUser(value.target.value); field.onChange(value);}}
                                    />
                                    {errors.isAdminUser && <span style={ErrorStyle}>{t("Please choose an option")}</span>}
                                    </>
                                )}
                                />
                            </div>
                    </Grid>
                </Grid> */}
                {/* <Grid container spacing={2} className='mb-20'>
                    <Grid item m sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Active")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <Controller
                                name="isActive"
                                control={control}
                                rules={{ required: t("Please select an option") }} // Add the required rule
                                render={({ field }) => (
                                    <>
                                    <RadioButtonGroup
                                        key={field.value}
                                        className={['create-using-account-radio', field.value === "Yes" ? "yes" : "no"].join(' ')}
                                        value={field.value}
                                        labels={['Yes', 'No']}
                                        handleChange={(value) => field.onChange(value)}
                                    />
                                    {errors.isActive && <span style={ErrorStyle}>{errors.isActive.message}</span>}
                                    </>
                                )}
                                />
                        </div>
                        {errors?.name?.type === "required" && <span style={ErrorStyle}>{t("Please choose the options")}</span>}
                    </Grid>
                </Grid> */}
                <Grid container spacing={2} className='mb-20'>
                    <Grid item m sm={12} xs={12}>
                        <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Select your Locations")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                        <BusinessUnitLocationMapping dataObj={isAdminUser}  businessOption={['All', ...Object.keys(locationsData)]}  selectedItems={selectedItems} setSelectedItems={setSelectedItems} bunitFilterList={bunitFilterCommonList} isBUser={true} page={"selfRegistration"}/>
                    </Grid>
                </Grid>
                { locationError && <span style={ErrorStyle}>{t("Please choose the options")}</span>}

                <Grid container spacing={2}>
                <Grid item xs={12} sm={12} xl={12} lg={12} md={12}>
                    <Styled.PrimaryButton
                            type='submit'
                            variant="contained"
                            sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: "100%", height: "51px" }}
                            color="primary"
                            className="xxs-bold"
                            disabled={isLoading}
                        >
                             {isLoading ? (<><CircularProgress className='progress-color' /><span style={{color:'#fff'}}>{t("Saving...")}</span></>) : <span>{t("Save")}</span>}
                        </Styled.PrimaryButton>
                    </Grid>
                    {/* <Grid item xs={12} sm={6} xl={6} lg={6} md={6}>
                        <Styled.CancelButton
                            variant="outlined"
                            sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: "100%", height: "51px" }}
                            color="primary"
                            className="xxs-bold"
                            onClick={() => navigate('/user-management')}
                        >
                            {t("Cancel")}
                        </Styled.CancelButton>
                    </Grid> */}
                    
                </Grid>
            </form>
            </DialogContent>
        </Dialog>
    </>
       
  );
};

SelfRegistration.propTypes = {
    setBreadcrumb: PropTypes.func.isRequired,
    createNewUserMgt: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => {
    return {
        setBreadcrumb: (menu) => dispatch(menuActions.setSubmenu(menu)),
        createNewUserMgt: (data) => dispatch(userActions.createNewUserMgt(data)),
        getRolesLov: () => dispatch(userActions.getRolesLov()),
        getBUnitLov: () => dispatch(userActions.getBUnitLov()),
    };
}
const mapStateToProps = (state) => ({ 
    createdUserMgtData: state.userReducer.createdUserMgtData,
    rolesLov: state.userReducer.rolesLov,
    bunitFilterCommonList: state.userReducer.bunitFilterCommonList,
 })


export default connect(mapStateToProps, mapDispatchToProps)(SelfRegistration);

